import { whatsappIntegrationActionTypes } from '../../actions/integrations/whatsappIntegrationActions';

const WhatsappIntegrationReducers = (state = { }, action) => {
  switch (action.type) {
  case whatsappIntegrationActionTypes.GET_WHATSAPP_CONNECTIONS.LOADING: {
    const { getWhatsappConnectionsLoading } = action;
    return {
      ...state,
      getWhatsappConnectionsLoading,
    };
  }
  case whatsappIntegrationActionTypes.GET_WHATSAPP_CONNECTIONS.SUCCESS: {
    const { whatsappConnections } = action;
    return {
      ...state,
      whatsappConnections,
    };
  }
  case whatsappIntegrationActionTypes.UPDATE_WHATSAPP_CONFIGURATION.LOADING: {
    const { updateWhatsappConfigurationLoading } = action;
    return {
      ...state,
      updateWhatsappConfigurationLoading,
    };
  }
  case whatsappIntegrationActionTypes.TOGGLE_WHATSAPP.LOADING: {
    const { toggleWhatsappLoading } = action;
    return {
      ...state,
      toggleWhatsappLoading,
    };
  }
  case whatsappIntegrationActionTypes.SEND_WHATSAPP_NOTIFICATION.LOADING: {
    const { sendWhatsappNotificationLoading } = action;
    return {
      ...state,
      sendWhatsappNotificationLoading,
    };
  }

  default: {
    return state;
  }
  }
};

export default WhatsappIntegrationReducers;
